// React Components
import * as React from 'react';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

// Material UI Components
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';


// Audit Vault Components
import { loginToMicrosoft } from '../utilities/common-user-utils';
import { logoutFromMicrosoft } from '../utilities/common-auth-utils';
import HeaderMessageIndicator from './common/HeaderMessageIndicator';


const isUat = process.env.REACT_APP_ENVIRONMENT === 'UAT';

export default function MainAppBar(props) {

  const { user, setUser } = props;

  const { instance, accounts } = useMsal();
  const drawerWidth = 240;
  const isAuthenticated = useIsAuthenticated();
  const name = accounts[0] && accounts[0].name;
  const initials = name
    ? name.split(' ').filter(Boolean).slice(0, 2).map(part => part[0]).join('').toUpperCase()
    : '';
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.location.href = "/myprofile";
  };

  const handleLogout = () => {
      setAnchorEl(null);
      logoutFromMicrosoft(instance, accounts);
  };


  return (
    <AppBar
    position="fixed"
    elevation={0}
    sx={{
      width: `calc(100% - ${drawerWidth}px)`,
      ml: `${drawerWidth}px`,
      bgcolor: isUat ? 'mediumseagreen' : 'primary.main',
      color: 'common.white',
      borderBottom: '1px solid',
      borderColor: 'divider',
      zIndex: theme => theme.zIndex.drawer + 1,
    }}>
    <Toolbar sx={{ minHeight: 64 }}>
    <Typography variant="h6" component="span" sx={{ flexGrow: 1 }}>
      Audit Vault for M365{isUat ? ' - UAT' : ''}
    </Typography>
    <Box sx={{ textAlign: 'right' }}>
    {isAuthenticated ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <HeaderMessageIndicator user={user} />
          <Typography variant="body2" sx={{ display: { xs: 'none', lg: 'block' }, fontWeight: 500 }}>{name}</Typography>
          <IconButton
            size="small"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
          >
            <Avatar sx={{ width: 34, height: 34, bgcolor: 'common.white', color: 'primary.main', fontSize: '0.85rem', fontWeight: 600 }}>
              {initials}
            </Avatar>
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose}>Profile</MenuItem>
            <MenuItem onClick={() => handleLogout()}>Sign out</MenuItem>
          </Menu>
        </Box>
      ) :
        <Button
          onClick={() => loginToMicrosoft(instance)}
          aria-label="Sign in with Microsoft"
          variant="outlined"
          startIcon={
            <Box
              component="svg"
              aria-hidden="true"
              viewBox="0 0 21 21"
              sx={{
                width: 18,
                height: 18,
                display: 'block',
                flexShrink: 0,
              }}
            >
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </Box>
          }
          sx={{
            minHeight: 38,
            px: 1.75,
            bgcolor: 'common.white',
            color: '#334155',
            borderColor: 'rgba(255, 255, 255, 0.7)',
            '& .MuiButton-startIcon': {
              ml: 0,
              mr: 1,
            },
            '&:hover': {
              bgcolor: '#f8fafc',
              borderColor: 'common.white',
            },
          }}
        >
          Sign in
        </Button>
      }
    </Box>
    </Toolbar>
    </AppBar>
  );
}
